import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M90.12 105.13c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#D8FFFF" d="M18.48 18.72a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M6.57 32.38a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M15.98 102.53c-.38 0-.77-.15-1.06-.44-.59-.59-.59-1.54 0-2.12l9.99-9.99a1.49 1.49 0 0 1 2.12 0c.58.59.59 1.54 0 2.12l-9.99 9.99c-.29.29-.68.44-1.06.44"
    />
    <path
      fill="#00D8D8"
      d="M25.98 102.53c-.38 0-.77-.15-1.06-.44l-9.99-9.99a1.49 1.49 0 0 1 0-2.12c.59-.58 1.54-.59 2.12 0l9.99 9.99c.59.59.59 1.54 0 2.12-.29.29-.68.44-1.06.44M67.01 29.04c-.83 0-1.5-.67-1.5-1.5V13.41c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v14.13c0 .83-.67 1.5-1.5 1.5"
    />
    <path
      fill="#00D8D8"
      d="M74.08 21.98H59.95c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h14.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5"
    />
    <path
      fill="#0597A3"
      d="M73.61 36.54c10.2-.01 19.6 5.51 24.56 14.42a28.05 28.05 0 0 1-.7 28.47l6.12 12.86c.71 1.49-.85 3.05-2.34 2.34L88.39 88.5c-11.94 7.43-27.87 5.01-37.03-6.59-4.5-5.7-6.59-13.05-5.77-20.26 1.67-14.69 13.95-25.13 28.01-25.11z"
    />
    <path
      fill="#001A43"
      d="M88 61.25H60c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h28c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M88 73.25H66c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#00D8D8"
      d="M39.81 24.12c-10.2-.01-19.6 5.51-24.56 14.42a28.05 28.05 0 0 0 .7 28.47L9.83 79.87c-.71 1.49.85 3.05 2.34 2.34l12.86-6.13c11.94 7.43 27.87 5.01 37.03-6.59 4.5-5.7 6.59-13.05 5.77-20.26-1.67-14.69-13.95-25.13-28.01-25.11z"
    />
    <path
      fill="#001A43"
      d="M53 48.25H25c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h28c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M47 60.25H25c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconLiveChatBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconLiveChatBrand);
export default Memo;
